//#region [IMPORT]

import { useEffect, useState } from 'react';
import { prokeyApi } from 'api/prokey';
import { useLogout } from 'components/useLogout';
import { onConnection } from 'api/prokey/prokey.websocket';

//#endregion

//-----------------------------------------------------------------
export const useUserDetails = () => {
  //-----------------------------------------------------------------

  //#region [VALUES]

  const [details, setDetails] = useState( { roles: [] } );
  const logout = useLogout();

  //#endregion

  useEffect( () => {
    //-----------------------------------------------------------------
    async function getUserDetails() {
      //-----------------------------------------------------------------
      try {
        const response = await prokeyApi.getUserDetails();
        
        const data = response.data;
        data.display_name =  `${data.FirstName} ${data.LastName} (${data.Username})`;
        data.initials = 
          data.FirstName.substring( 0, 1 )
        + data.LastName .substring( 0, 1 );

        setDetails( data );
      } catch(error) {
        console.warn( 'Failed to retrieve user details.' );
        logout();
        console.error(error);
      }
    }

    onConnection( getUserDetails );

    getUserDetails();

  }, [] );

  return details;
}